const STORAGE_KEY = 'workloop.highlightedPopupEnabled';
const EVENT_NAME = 'workloop:highlight-prefs-changed';

let cache = null;

const readEnabled = () => {
  if (cache !== null) return cache;
  try {
    cache = localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    cache = false;
  }
  return cache;
};

const writeEnabled = (enabled) => {
  cache = Boolean(enabled);
  try {
    localStorage.setItem(STORAGE_KEY, cache ? 'true' : 'false');
  } catch {
    // ignore quota
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(EVENT_NAME));
  }
};

export const isHighlightedPopupEnabled = () => readEnabled();

export const setHighlightedPopupEnabled = (enabled) => {
  writeEnabled(enabled);
  return readEnabled();
};

/** All bell notifications toast on the bottom right when the global switch is on. */
export const isNotificationHighlighted = () => readEnabled();
